

import axiosInstance from "../configuration/request";
import { baseColumns, clothColumns, tailoringColumns, washAndFoldColumns } from "../constants/bussiness";
import { buildServicesDetailsPayload } from "./buildUserPayload"; 

export const serviceTypeValueToLabel = (value) => {
  switch (value) {
    case "DRYCLEANING":
      return "Dry Cleaning";
    case "IRONING":
      return "Ironing";
    case "TAILORING":
      return "Tailoring";
    case "WASH_N_FOLD":
      return "Wash & Fold";
    default:
      return value;
  }
};

export const getColumnsByServiceType = (type) => {
  switch(type) {
    case "TAILORING": return tailoringColumns;
    case "IRONING":
    case "DRYCLEANING": return clothColumns;
    case "WASH_N_FOLD": return washAndFoldColumns;
    default: return baseColumns;
  }
};

 export const generateServicesData = (serviceData ) => {

    
    const formattedUser = serviceData?.map((service) => {
      const formattedItem = {
        id: service?.id,
        serviceType: service?.serviceType,
        service_type: serviceTypeValueToLabel(service?.serviceType),

      };
      if (service?.unitDetails?.length > 0) {
        formattedItem.unit_pound_id = service?.unitDetails[0]?.id;
        formattedItem.category = service?.unitDetails[0]?.category || "";
        formattedItem.unit = "piece";
        formattedItem.description = service?.unitDetails[0]?.description || "-";
        formattedItem.clothType = service?.unitDetails[0]?.cloth_name || "-";
        if (service?.unitDetails[0]?.serviceType === "TAILORING") {
          formattedItem.tailoringType =
            service?.unitDetails[0]?.tailoringType?.name || "";
          formattedItem.price =
            service?.unitDetails[0]?.tailoringType?.price || "";
        } else {
          formattedItem.price = service?.unitDetails[0]?.price || "";
        }
      }
      if (service?.poundDetails?.length > 0) {
        formattedItem.description =
          service?.poundDetails[0]?.description || "-";
        formattedItem.category = service?.poundDetails[0]?.category || "";
        formattedItem.unit = "pound";
        formattedItem.price = service?.poundDetails[0]?.price || "";
        formattedItem.unit_pound_id = service?.poundDetails[0]?.id;
        formattedItem.lbs = service?.poundDetails[0]?.quantity || "";
      }
      return formattedItem;
    });
    return formattedUser;
  };

export function creatService(service, storeId) {
    let serviceData = buildServicesDetailsPayload(service);
    let payload = [
      {
        ...serviceData,
        serviceType: serviceData.serviceType,
        storeId: storeId,
        ...(serviceData.poundDetails && {
          poundDetails: [serviceData.poundDetails],
        }),
        ...(serviceData.unitDetails && {
          unitDetails: [serviceData.unitDetails],
        }),
      },
    ];
    const response = axiosInstance.post(`/customer/services-offered`, payload);
    return response
  
}

export function updateService(service, storeId) {
       let payload = {
        storeId: storeId,
        serviceType: service.serviceType,
        itemId: service.itemId,
        category: service.category,
        description: service.description,
        price : Number(service.price)
      };
      if (service.clothType) {
        payload.cloth_name = service.clothType;
      }
      if (service.lbs) {
        payload.quantity = Number(service.lbs);
      }
      if (service.serviceType === "TAILORING") {
        payload.tailoringType = {
          name: service.tailoringType,
          price: Number(service.price),
        };
      } 
      // else {
      //   payload.price = Number(service.price);
      // }
      
    const response = axiosInstance.patch(`/customer/services-offered`, payload);
    return response
      
}